import DateInput from "components/elements/DateInput";
import IconButton from "components/elements/IconButton";
import Select from "components/elements/Select";
import Table from "components/elements/Table";
import Toggle from "components/elements/Toggle";
import ToolTip from "components/elements/ToolTip";
import {
  CLIENT_BROADCASTER,
  CLIENT_CONTACT_TYPES,
  CLIENT_CONTACT_TYPES_REVERSE,
  CLIENT_TYPES,
  LS_CLONE_CLIENT_KEY,
} from "core/Constants";
import dataProvider from "core/DataProvider";
import { useEffect, useState,useCallback } from "react";
import { toast } from "react-hot-toast";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ReactComponent as AddIcon } from "../../../images/add.svg";
import { ReactComponent as EditIcon } from "../../../images/edit.svg";
import utility from "core/Utils";
import Input from "components/elements/Input";
import Modal from "components/elements/Modal";
import GroupSpotRenewForm from "./RenewGroupSpotsAddendum";


const headerMap = {
  contactType: "Type",
  contactName: "Name",
  contactDesignation: "Designation",
  contactEmail: "Email",
  contactMobile: "Mobile",
  action: "Actions",
};

const NewClient = () => {
  const [accountType, setAccountType] = useState({
    value: "new",
    label: "New",
  });
  const [groupName, setGroupName] = useState("");
  const [clientId, setClientId] = useState(0);
  const [clientName, setClientName] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [subscriptionFrom, setSubscriptionFrom] = useState("");
  const [subscriptionTo, setSubscriptionTo] = useState("");
  const [totalSpots, setTotalSpots] = useState("");
  const [totalUsers, setTotalUsers] = useState("");
  const [customRate, setCustomRate] = useState("");
  const [isAllAdvertiser, setIsAllAdvertiser] = useState(true);
  const [clientType, setClientType] = useState(null);
  const [financeCode, setFinanceCode] = useState("");
  const [accountManager, setAccountManager] = useState(null);
  const [clientSpots, setClientSpots] = useState("");
  const [prepaidSpots, setPrepaidSpots] = useState("");
  const [clientUsers, setClientUsers] = useState("");
  const [address, setAddress] = useState("");
  const [isUserWiseSubscription, setIsUserWiseSubscription] = useState(true);
  const [isAutoCSV, setIsAutoCSV] = useState(true);
  const [toleranceDays, setToleranceDays] = useState("");
  const [backDays, setBackDays] = useState("");
  //const [adminId, setAdminId] = useState(0);
  const [adminName, setAdminName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminEmailold, setAdminEmailold] = useState("");
  const [contactType, setContactType] = useState(null);
  const [contactName, setContactName] = useState("");
  const [contactDesignation, setContactDesignation] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactMobile, setContactMobile] = useState("");
  const [contacts, setContacts] = useState([]);
  const [existingGroups, setExistingGroups] = useState([]);
  const [allocatedSpots, setAllocatedSpots] = useState(0);
  const [allocatedUsers, setAllocatedUsers] = useState(0);
  const [consumptionAlert, setConsumptionAlert] = useState(90);

  const [progress, setProgress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [groupData, setGroupData] = useState(null);
  const [contactEditIndex, setContactEditIndex] = useState(null);

  const [oldGroupData, setOldGroupData] = useState([]);
  const [clientGroupId, setClentGroupId] = useState("");
  const [renewisPreview, setRenewIsPreview] = useState(false);
  //const [RenewSportGrpformData, setGrpRenewSpotFormData] = useState({});
  const [headingText, setHeadingText] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [isCheckedSC, setIsChecked] = useState(false);
  const [isReadOnlyCName, setIsReadOnlyCName] = useState(false);
    const [isReadOnlyCEmail, setIsReadOnlyCEmail] = useState(false);
    const [isReadOnlyConType, setisReadOnlyConType] = useState(false);
    const [isica, setIsICA] = useState(false);
  const token = useOutletContext();
  const previewGrpRenewModal = (
    <GroupSpotRenewForm
      onClose={(action = null) => {
        setRenewIsPreview(false);
        handleChangeGroup(selectedGroup);
      }}
      data={{ 'grp_heading': headingText, 'gid': clientGroupId }}
      allowClone={true}
      allowModify={!token.client_type}
    />
  );
  const modal = (
    <Modal onClose={() => setModalVisible(false)}></Modal>
  );
  const navigate = useNavigate();

  // Data Lists
  const [accountManagers, setAccountManagers] = useState([]);

  // Fetchers
  const getAccountManagers = async () => {
    let ac = await dataProvider.network.get("masters/account-manager");
    if (ac) {
      const editData = JSON.parse(localStorage.getItem(LS_CLONE_CLIENT_KEY));
      if (editData) {
        let selectedAccountManager = "";
        for (let i = 0; i < ac.length; i++) {
          ac[i] = { value: ac[i].id, label: ac[i].name };

          if (parseInt(ac[i].value) === parseInt(editData.manager_id)) {
            selectedAccountManager = ac[i];
          }
        }
        setEditData(editData);
        setAccountManagers(ac);
        setAccountManager(selectedAccountManager);
      } else {
        setAccountManagers(
          utility.sortBy(
            ac.filter(x => x.status).map(x => ({ value: x.id, label: x.name })),
            "label"
          )
        );
      }
    } else {
      toast.error("Failed to load account managers");
    }
  };

  const getExistingGroups = useCallback(async () => {
    let d = await dataProvider.network.get("min-master/groups");
    if (d) {
      // edit conditions
      const editData = JSON.parse(localStorage.getItem(LS_CLONE_CLIENT_KEY));
      console.log('edit',editData);
      if (editData) {
        let selectedGroup = "";
        for (let i = 0; i < d.length; i++) {
          d[i] = { value: d[i].id, label: d[i].name };

          if (parseInt(d[i].value) === parseInt(editData.group_id)) {
            selectedGroup = d[i];
          }
        }

        editData.users = editData.users.map(x => JSON.parse(x));
        editData.contacts = editData.contacts.map(x => JSON.parse(x));

        let admin = {};
        let smallestId = null;
        for (let i = 0; i < editData.users.length; i++) {
          if (!smallestId) {
            smallestId = editData.users[i].id;
            admin = editData.users[i];
          } else {
            if (editData.users[i].id < smallestId) {
              smallestId = editData.users[i].id;
              admin = editData.users[i];
            }
          }
        }

        let contacts = [];
        for (let i = 0; i < editData.contacts.length; i++) {
          contacts.push({
            contactType: {
              value: editData.contacts[i].client_contact_type,
              label:
                CLIENT_CONTACT_TYPES_REVERSE[
                editData.contacts[i].client_contact_type
                ],
            },
            contactName: editData.contacts[i].name,
            contactDesignation: editData.contacts[i].designation,
            contactEmail: editData.contacts[i].email,
            contactMobile: editData.contacts[i].mobile,
          });
        }

        setIsEdit(true);
        setAccountType({ value: "existing", label: "Existing" });
        console.log('exiting grp',selectedGroup);
        setSelectedGroup(selectedGroup);
        setGroupName(selectedGroup.label);
        setClentGroupId(editData.group_id);
        handleChangeGroup(selectedGroup);
        setClientId(editData.client_id);
        setClientName(editData.client_name);
        setAddress(editData.address);
        setClientSpots(editData.total_spot);
        setPrepaidSpots(editData.prepaid_spots);
        setClientUsers(editData.total_user);
        setToleranceDays(editData.tolerance_days);
        setBackDays(editData.back_days);
        setFinanceCode(editData.finance_code);
        setIsUserWiseSubscription(editData.userwise_subscription);
        setIsAutoCSV(editData.auto_csv);
       // setAdminId(admin.id);
        setAdminName(admin.name);
        setAdminEmail(admin.email);
        setAdminEmailold(admin.SAMECONTACT);
        setContacts(contacts);
       // alert(admin.SAMECONTACT);
        setIsChecked(admin.SAMECONTACT);
      } else {
        for (let i = 0; i < d.length; i++) {
          d[i] = { value: d[i].id, label: d[i].name };
        }
      }

      utility.sortBy(d, "label");

      setExistingGroups(d);

    } else {
      toast.error("Failed to load existing groups");
    }
  }, []);

  // mount
  useEffect(() => {
    getAccountManagers();
    getExistingGroups();
  }, [getExistingGroups]);

  // unmount
  useEffect(() => {
    return () => {
      localStorage.removeItem(LS_CLONE_CLIENT_KEY);
    };
  }, []);

  // on contacts list update
  useEffect(() => {
    if (contacts.length) {
      // add the actions
      let c = [...contacts];
      for (let i = 0; i < c.length; i++) {
        c[i].action = (
          <div className="action flex flex-v-center">
            <div
              className="action-button flex flex-center"
              onClick={(event) => {
                setEditContact(event,i);
              }}
            >
              <EditIcon />
            </div>
            <div
              className="action-button flex flex-center"
              onClick={() => {
                removeContact(i);
              }}
            >
              <AddIcon style={{ transform: "rotate(45deg)" }} />
            </div>
          </div>
        );
      }

      setContacts(c);
    }
  }, [contacts.length, contactEditIndex]);

  const submit = async e => {
    e.preventDefault();

    // validations
    try {
      // new case
      if (accountType.value === "new") {
        // group level
        if (!groupName || groupName.length < 2) {
          throw new Error("Group name should be at least 3 characters");
        }
        if (!clientType || !clientType.value) {
          throw new Error("Please select a client type");
        }
        if (!subscriptionFrom) {
          throw new Error("Please select a subscription from date");
        }
        if (!subscriptionTo) {
          throw new Error("Please select a subscription to date");
        }
        if (!totalUsers || totalUsers < 1) {
          throw new Error("Please assign at least 1 user to the group");
        }
        if (!totalSpots || totalSpots < 1) {
          throw new Error("Please assign at least 1 spot to the group");
        }

        // client level
        if (!clientName || clientName.length < 2) {
          throw new Error("Client name should be at least 3 characters");
        }
        if (!address || address.length < 5) {
          throw new Error("Address should be at least 5 characters");
        }
        if (!accountManager || !accountManager.value) {
          throw new Error("Please select an account manager");
        }
        if (!clientSpots || clientSpots < 1) {
          throw new Error("Pleast assign at least 1 spot the client");
        }
        if (clientSpots > totalSpots) {
          throw new Error("Client spots cannot exceed group spots");
        }
        if (!clientUsers || clientUsers < 1) {
          throw new Error("Please assign at least 1 user to the client");
        }
        if (!toleranceDays || toleranceDays < 1) {
          throw new Error("Please assign at least 1 tolerance days");
        }
        if (!backDays || backDays < 1) {
          throw new Error("Please assign at least 1 back days");
        }
        if (!financeCode || financeCode.length < 1) {
          throw new Error("Invalid finance code");
        }
        if (!adminName || adminName.length < 2) {
          throw new Error("Admin name should be at least 3 characters");
        }
        if (!adminEmail || !utility.validation.emailRegex.test(adminEmail)) {
          throw new Error("Invalid admin email");
        }
      } else {
        if (!selectedGroup) {
          throw new Error("Please select a group");
        }
        if (!clientName || clientName.length < 2) {
          throw new Error("Client name should be at least 3 characters");
        }
        if (!address || address.length < 5) {
          throw new Error("Address should be at least 5 characters");
        }
        if (!accountManager || !accountManager.value) {
          throw new Error("Please select an account manager");
        }
        if (!clientSpots || clientSpots < 1) {
          throw new Error("Pleast assign at least 1 spot the client");
        }
        if (clientSpots > totalSpots) {
          throw new Error("Client spots cannot exceed group spots");
        }
        if (!clientUsers || clientUsers < 1) {
          throw new Error("Please assign at least 1 user to the client");
        }
        if (!toleranceDays || toleranceDays < 1) {
          throw new Error("Please assign at least 1 tolerance days");
        }
        if (!backDays || backDays < 1) {
          throw new Error("Please assign at least 1 back days");
        }
        if (!financeCode || financeCode.length < 1) {
          throw new Error("Invalid finance code");
        }
        if (!adminName || adminName.length < 2) {
          throw new Error("Admin name should be at least 3 characters");
        }
        if (!adminEmail || !utility.validation.emailRegex.test(adminEmail)) {
          throw new Error("Invalid admin email");
        }
      }

      if (isEdit) {
        if (totalSpots < groupData.spots) {
          throw new Error("Assign spots of group cannot be reduced");
        }

        if (totalUsers < groupData.users) {
          throw new Error("Assign users of group cannot be reduced");
        }
      }
    } catch (error) {
      toast.error(error.message);
      return;
    }

    setProgress(true);
    try {
      console.log('grp id',selectedGroup.value,selectedGroup,accountType.value);
      let data = {
        group_id:
          accountType.value === "existing" ? parseInt(selectedGroup) : 0,
        group_name: groupName,
        client_id: clientId,
        client_type: parseInt(clientType.value),
        subscription_from: subscriptionFrom,
        subscription_to: subscriptionTo,
        spots: parseInt(totalSpots),
        users: parseInt(totalUsers),
        custom_rate: parseFloat(customRate),
        is_multiple_advertiser: isAllAdvertiser,
        client_name: clientName,
        client_spots: parseInt(clientSpots),
        account_manager: parseInt(accountManager.value),
        finance_code: financeCode,
        address: address,
        client_users: parseInt(clientUsers),
        auto_csv: Boolean(isAutoCSV),
        userwise_subscription: Boolean(isUserWiseSubscription),
        tolerance_days: parseInt(toleranceDays),
        back_days: parseInt(backDays),
        admin_name: adminName,
        admin_email: adminEmail,
        contacts: [],
        consumption_alert_percent: consumptionAlert,
        same_as_contact: isCheckedSC,
        is_ica:isica,
      };

      let hadMailAuthority = false;

      for (let i = 0; i < contacts.length; i++) {
        let contact = contacts[i];
        data.contacts.push({
          contact_type: parseInt(contact.contactType.value),
          name: contact.contactName,
          designation: contact.contactDesignation,
          email: contact.contactEmail,
          mobile: contact.contactMobile.toString(),
        });

        if (
          parseInt(contact.contactType.value) ===
          CLIENT_CONTACT_TYPES.MAIL_AUTHORITY
        ) {
          hadMailAuthority = true;
        }
      }

      if (data.userwise_subscription && !hadMailAuthority) {
        toast.error("One mail authority is required");
        return;
      }
      if ((parseInt(oldGroupData.spots) !== parseInt(totalSpots)) && accountType.value === "existing") {
        console.log("Before exit");
        toast.error("Cannot edit group spot");
        return;
        // await dataProvider.network.post("client/onboard", data);
        // toast.success(
        //   isEdit ? "Client updated successfully" : "Client onboarded successfully"
        // );

      } else {
     //  console.log('post data',data);
        await dataProvider.network.post("client/onboard", data);
        toast.success(
          isEdit ? "Client updated successfully" : "Client onboarded successfully"
        );
      }
      navigate("/clients/all");
    } catch (error) {
      console.error(error);
      toast.error("Failed to onboard client");
    } finally {
      setProgress(false);
    }
  };

  // Handlers
  const setEditContact = (event, index) => {
   // alert(index);
    if (event?.preventDefault) event.preventDefault();
    let item = contacts[index];
   // alert(item.contactName);
   if(isCheckedSC){
  setContactName(adminName);
  setContactEmail(adminEmail);
   }else{
 setContactName(item.contactName);
  setContactEmail(item.contactEmail);
   }

    setContactDesignation(item.contactDesignation);

    setContactMobile(item.contactMobile);
    setContactType(item.contactType);
    setContactEditIndex(index);

    // if(adminName != "" && adminEmail !="" && isEdit && contacts.length > 0){
    //       setisReadOnlyConType(true);
    //    setIsReadOnlyCName(true);
    //    setIsReadOnlyCEmail(true);
    // }else{
    //     setisReadOnlyConType(false);
    //    setIsReadOnlyCName(false);
    //    setIsReadOnlyCEmail(false);
    // }

  };

  const addEditContact = () => {
    // validations
    try {
      if (!contactType || !contactType.value) {
        throw new Error("Please select contact type");
      }

      if (!contactEmail || !contactEmail.length) {
        throw new Error("Please provide an email address");
      }
      if(isCheckedSC==false){
      if (
        parseInt(contactType.value) === CLIENT_CONTACT_TYPES.MAIL_AUTHORITY &&
        contactEmail.toLowerCase() === adminEmail.toLowerCase()
      ) {
        throw new Error(
          "Admin and Mail authority cannot have same email address"
        );
      }
    }
      let contactsToCheck = contacts.filter((x, i) => i !== contactEditIndex);
      if (
        contactsToCheck
          .map(x => x.contactEmail.toLowerCase())
          .includes(contactEmail)
      ) {
        throw new Error("Contact with same email is already in the list");
      }
    } catch (error) {
      toast.error(error.message);
      return;
    }

    let items = [...contacts];
    if (contactEditIndex !== null) {
      // edit case
      items[contactEditIndex] = {
        contactName,
        contactDesignation,
        contactEmail,
        contactMobile,
        contactType,
      };

      setContactEditIndex(null);
    } else {
      // add case
      let item = {
        contactName,
        contactDesignation,
        contactEmail,
        contactMobile,
        contactType,
      };

      if(contacts.length > 0 && isCheckedSC){
        alert('rrr');
           toast.error("Only one contact is allowed.");
           return;
      }else{
        items.push(item);
      }


    }
//alert(contacts.length);
    // update contacts
     if(contacts.length == 0 && isCheckedSC){
       // alert('rrr1111');
    setContacts(items);
     }else{
 setContacts(items);
     }
  //alert('rrr222');
    // reset contact input fields
    setContactType(null);
    setContactName("");
    setContactDesignation("");
    setContactEmail("");
    setContactMobile("");
  };

  const getMaxClientSpots = () => {
    let maxClientSpots = 0;
    if (accountType.value === "new") {
      maxClientSpots = parseInt(totalSpots) || 0;
    } else {
      if (isEdit) {
        //console.log("22"+editData);
        let cspot = editData ? editData.total_spot : clientSpots;
        maxClientSpots =totalSpots - (allocatedSpots - cspot);
        } else {
        maxClientSpots = totalSpots - allocatedSpots;
      }
    }

    return maxClientSpots;
  };

  const getMaxClientUsers = () => {
    let maxClientUsers = 0;
    if (accountType.value === "new") {
      maxClientUsers = parseInt(totalUsers) || 0;
    } else {
      if (isEdit) {
        let cuser = editData ? editData.total_user : clientUsers;
        maxClientUsers = totalUsers - (allocatedUsers - cuser);
      } else {
        maxClientUsers = totalUsers - allocatedUsers;
      }
    }

    return maxClientUsers;
  };

  const handleConsumptionChange = e => {
    let val = e.target.value;

    if (val === "") {
      setConsumptionAlert(val);
    } else {
      val = parseFloat(val);
      if (!val) {
        val = 90;
      }

      if (val > 100 || val < 1) {
        val = 90;
      }

      setConsumptionAlert(val);
    }
  };

  const handleAssignSpots = e => {
    console.log('step 1'+totalSpots);
    let ts = parseInt(totalSpots);
    if (!ts) {
      return;
    }

    let val = e.target.value;
    console.log('step 2'+e.target.value);
    if (val === "") {
      setClientSpots(val);
      return;
    } else {
      val = parseInt(val);
      if (!val) {
        return;
      }
    }

    let maxClientSpots = getMaxClientSpots();
    //let maxClientSpots = ts;
    // console.log('step 2 '+val);
   //   console.log('step 66 '+maxClientSpots);
    if (val > maxClientSpots) {
      return;
    }

    setClientSpots(val);
  };

  const handleAssignUsers = e => {
    let tu = parseInt(totalUsers);
    if (!tu) {
      return;
    }

    let val = e.target.value;
    if (val === "") {
      setClientUsers(val);
      return;
    } else {
      val = parseInt(val);
      if (!val) {
        return;
      }
    }

    let maxClientUsers = allocatedUsers
      ? totalUsers - allocatedUsers
      : totalUsers
        ? totalUsers
        : null;

    if (val > maxClientUsers) {
      return;
    }

    setClientUsers(val);
  };

  const handleChangeGroup = async val => {
    //console.log('selected group',val.value,val);
if(typeof val.value === 'undefined'){
  var tv = val;
 // console.log('selected group2222',val);
}else{
  var tv = val.value;
 // console.log('selected group333',val.value);
}
console.log('selected group2',tv);
    try {
      let data = await dataProvider.network.get("group?id=" + tv);

      setClientType({
        label: CLIENT_TYPES[data.client_type],
        value: data.client_type,
      });
      console.log(data.subscription_from);
      setSelectedGroup(tv);
      //selectedGroup
      setGroupName(data.name);
      setSubscriptionFrom(data.subscription_from);
      setSubscriptionTo(data.subscription_to);
      setTotalSpots(data.spots);
      setTotalUsers(data.users);
      setCustomRate(data.custom_rate ? data.custom_rate : "");
      setIsAllAdvertiser(data.is_multiple_advertiser);
      setAllocatedSpots(data.allocated_spots);
      setAllocatedUsers(data.allocated_users);
      setGroupData(data);
      setOldGroupData(data);
      setIsICA(data.is_ica)

    setClentGroupId(tv);

  //  setSelectedGroup(selectedGroup);

    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch the group details");
    }
  };

  const removeContact = index => {
    let c = [...contacts];
    c.splice(index, 1);
    setContacts(c);
  };

  const renewGroupSpotPopUp = async grp_id => {
    setHeadingText(
      groupName +
        ' - (' +
        new Date(subscriptionFrom).getFullYear() +
        ' to ' +
        new Date(subscriptionTo).getFullYear() +
        ')'
    );
    setModalVisible(true);
    setRenewIsPreview(true);
    console.log('1' + headingText);
  };
const setSameContact = (e) =>{
var cv =  e.target.checked;
//alert('tttt'+cv);
 setIsChecked(cv);
}
  const setUserRoleAaClient = (e,f) => {
    if(f===1){
 var cv =  isCheckedSC;
    }else{
 var cv =  e.target.checked;
    }

       //alert(cv);
      if(cv){
        //alert('111');
       if(adminName != "" && adminEmail !=""){

        if(adminName != "" && adminEmail !="" && isEdit && contacts.length > 0){
        setEditContact(null,0);
        removeContact(0);
       }
       // setIsChecked(true);
        setContactType({label: 'Mail Authority', value: '1'});
        setisReadOnlyConType(true);
       setContactName(adminName);
       setIsReadOnlyCName(true);
       setContactEmail(adminEmail);
       setIsReadOnlyCEmail(true);
      }else{
           toast.error("insert username and user email");
      }
     // alert(f);
      if(f===1){
         setEditContact(null,0);
        removeContact(0);
      }
      }else{
        //alert('222');
     // setIsChecked(false);
      setContactType(null);
        setContactName("");
        setContactEmail("");
        if(adminEmailold){
 setEditContact(null,0);
        removeContact(0);
        }

        setisReadOnlyConType(false);
      }
  }

  let maxClientSpots = getMaxClientSpots();
  let maxClientUsers = getMaxClientUsers();

  return (

    <section id="new-client-container">
      {renewisPreview && previewGrpRenewModal}
      <div className="flex">
        <div className="right flex flex-v-center">
          {progress ? (
            <div className="loader">
              <div className="lds-hourglass"></div>
            </div>
          ) : (
            <IconButton
              text={isEdit ? "Edit Client" : "Save Client"}
              onClick={submit}
            />
          )}
        </div>
      </div>
      <div className="group-details box mtop">
        <div className="prow" style={{ marginBottom: "1rem" }}>
          <h3>Group Details</h3>
        </div>
        <div className="prow flex flex-v-center">
          <div className="el flex-full">
            <Select
              placeholder="Account type"
              value={accountType}
              options={[
                { value: "new", label: "New" },
                { value: "existing", label: "Existing" },
              ]}
              onChange={val => setAccountType(val)}
              isDisabled={isEdit}
            />
          </div>
          <div className="el flex-full">
            {accountType && accountType.value === "new" ? (
              <input
                type="text"
                value={groupName}
                placeholder="Group Name"
                onChange={e => setGroupName(e.target.value)}
              />
            ) : isEdit ? (
              <input
                type="text"
                value={groupName}
                placeholder="Group Name"
                onChange={e => setGroupName(e.target.value)}
              />
            ) : (
              <Select
                placeholder="Select Group 1"
                value={selectedGroup.value}
                options={existingGroups}
                onChange={handleChangeGroup}
              />
            )}
          </div>
          <div className="el flex-full">
            <Select
              isDisabled={accountType.value === "existing"}
              placeholder="Client Type"
              value={clientType}
              onChange={val => setClientType(val)}
              options={[
                { value: 3, label: "Agency" },
                { value: 1, label: "Advertiser" },
                { value: 2, label: "Broadcaster" },
                { value: 4, label: "Other" },
              ]}
            />
          </div>
        </div>
        <div className="prow flex flex-v-center">
          <div className="el flex-full">
            {subscriptionFrom.value}
            <DateInput
              disabled={accountType.value === "existing"}
              value={subscriptionFrom}
              onChange={val => {
                setSubscriptionFrom(val);
              }}
              placeholder="Subscription From"
            />
          </div>
          <div className="el flex-full">
            <DateInput
              disabled={accountType.value === "existing"}
              value={subscriptionTo}
              onChange={val => {
                setSubscriptionTo(val);
              }}
              placeholder="Subscription To"
            />
          </div>

          <div className={`el ${isEdit || accountType.value === "existing" ? 'flex' : ''} flex-full`}>
            <Input
              disabled={isEdit || accountType.value === "existing"}
              type="text" style={{
                width: (isEdit || accountType.value === "existing") ? "40vh" : "", // or whatever alternate you need
                marginTop: isEdit || accountType.value === "existing" ? "5px" : "0px"
              }}
              placeholder="Assign Spots"
              value={totalSpots}
              onChange={e => setTotalSpots(parseInt(e.target.value) || "")}
            />
            {(isEdit || accountType.value === "existing") && (
              <IconButton
                text="Addendum" style={{}}
                onClick={() => renewGroupSpotPopUp(clientGroupId)}
              />
            )}
          </div>
        </div>
        <div className="prow flex flex-v-center">
          <div className="el flex-full">
            <Input
              disabled={accountType.value === "existing" && !isEdit}
              type="text"
              placeholder="Assign Users"
              value={totalUsers}
              onChange={e => setTotalUsers(parseInt(e.target.value) || "")}
            />
          </div>
          <div className="el flex-full">
            <Input
              disabled={accountType.value === "existing" && !isEdit}
              type="text"
              placeholder="Customize Rate (per spot)"
              value={customRate}
              onChange={e => setCustomRate(e.target.value)}
            />
          </div>
          <div className="el flex-full flex flex-v-center flex-center">
            <div className="el flex-full flex flex-v-center flex-center"><span style={{ fontSize: "0.875rem" }}>
              Multiple Advertisers
            </span>  <Toggle
              disabled={clientType && clientType.value === CLIENT_BROADCASTER}
              options={["Yes", "No"]}
              onChange={val => setIsAllAdvertiser(val === "Yes")}
              defaultLeft={isAllAdvertiser}
            />  </div>
            <div className="el flex-full flex flex-v-center flex-center">

          <span style={{ marginRight: "1rem", fontSize: "0.875rem" }}>
              ICA GROUP
            </span>
            <Toggle
               options={["Yes", "No"]}
              onChange={val => setIsICA(val === "Yes")}
              defaultLeft={isica}
            /></div>
          </div>
        </div>
      </div>
      <div className="client-details box mtop">
        <div className="prow" style={{ marginBottom: "1rem" }}>
          <h3>Client Details</h3>
        </div>
        <div className="prow flex flex-v-center">
          <div className="el flex-full">
            <Input
              type="text"
              value={clientName}
              onChange={e => setClientName(e.target.value)}
              placeholder="Client Name"
            />
          </div>
          <div className="el flex-full">
            <Input
              type="text"
              value={address}
              onChange={e => setAddress(e.target.value)}
              placeholder="Address"
            />
          </div>
        </div>
        <div className="prow flex flex-v-center">
          <div className="el flex-full">
            <Select
              placeholder="Account Manager"
              value={accountManager}
              onChange={val => setAccountManager(val)}
              options={accountManagers}
            />
          </div>
          <div className="el flex-full">
            {maxClientSpots !== null ? (
              <ToolTip text={`<b>Max:</b> ${maxClientSpots}`}>
                <Input
                  type="text"
                  value={clientSpots}
                  onChange={handleAssignSpots}
                  placeholder="Assign Spots"
                />
              </ToolTip>
            ) : (
              <Input
                type="text"
                value={clientSpots}
                onChange={handleAssignSpots}
                placeholder="Assign Spots"
              />
            )}
          </div>
          <div className="el flex-full">
            <Input
              type="text"
              value={prepaidSpots}
              onChange={e => setPrepaidSpots(e.target.value)}
              placeholder="Prepaid Spots"
            />
          </div>
        </div>
        <div className="prow flex flex-v-center">
          <div className="el flex-full">
            {maxClientUsers !== null ? (
              <ToolTip text={`<b>Max:</b> ${maxClientUsers}`}>
                <Input
                  type="text"
                  value={clientUsers}
                  onChange={handleAssignUsers}
                  placeholder="Assign Users"
                />
              </ToolTip>
            ) : (
              <Input
                type="text"
                value={clientUsers}
                onChange={handleAssignUsers}
                placeholder="Assign Users"
              />
            )}
          </div>
          <div className="el flex-full">
            <Input
              type="text"
              value={toleranceDays}
              onChange={e => setToleranceDays(parseInt(e.target.value) || "")}
              placeholder="Tolerance Days"
            />
          </div>
          <div className="el flex-full">
            <Input
              type="text"
              value={backDays}
              onChange={e => setBackDays(parseInt(e.target.value) || "")}
              placeholder="Back Days"
            />
          </div>
        </div>
        <div className="prow flex flex-v-center">
          <div className="el flex-full">
            <Input
              type="text"
              value={financeCode}
              placeholder="Finance Code"
              onChange={e => setFinanceCode(e.target.value)}
            />
          </div>
          <div className="el flex-full flex flex-center">
            <span style={{ marginRight: "1rem", fontSize: "0.875rem" }}>
              Userwise Subscription
            </span>
            <Toggle
              options={["Yes", "No"]}
              onChange={val => setIsUserWiseSubscription(val === "Yes")}
              defaultLeft={isUserWiseSubscription}
            />
          </div>
          <div className="el flex-full flex flex-center">
            <span
              style={{
                marginRight: "1rem",
                marginLeft: "1rem",
                fontSize: "0.875rem",
              }}
            >
              Auto CSV
            </span>
            <Toggle
              options={["Yes", "No"]}
              onChange={val => setIsAutoCSV(val === "Yes")}
              defaultLeft={isAutoCSV}
            />
          </div>
        </div>
      </div>
      <div className="user-details box mtop">
        <div className="prow" style={{ marginBottom: "1rem" }}>
          <h3>User Details</h3>
        </div>
        <div className="prow flex flex-v-center">
          <div className="el flex-full">
            <input
              type="text"
              value={adminName}
              onChange={e => setAdminName(e.target.value)}
              onBlur={() => setUserRoleAaClient(null,1)}
              placeholder="Admin Name"
            />
          </div>
          <div className="el flex-full">
            <input
              type="text"
              value={adminEmail}
              onChange={e =>setAdminEmail(e.target.value)}
              onBlur={() => setUserRoleAaClient(null,1)}
              placeholder="Admin Email"
            />
          </div>
          <div className="el flex-full" style={{ display: "flex", alignItems: "center" }}>

            <input
          type="checkbox"
          checked={isCheckedSC}
          onChange={e => {setSameContact(e); setUserRoleAaClient(e,0); }} style={{float:"left",width:"10%"}}
        />
 <h3>Same as Mail Authority</h3>
          </div>
        </div>
        <div className="prow" style={{ margin: "2rem 0 1rem 0" }}>
          <h3>Contact Details</h3>
        </div>
        <div className="prow flex flex-v-center">
          <div className="el flex-full">
            <Select
              placeholder="Contact Type"
              value={contactType}
              onChange={val => setContactType(val)} isDisabled={isReadOnlyConType}
              options={Object.keys(CLIENT_CONTACT_TYPES_REVERSE).map(k => ({
                label: CLIENT_CONTACT_TYPES_REVERSE[k],
                value: k,
              }))}

            />
          </div>
          <div className="el flex-full">
            <input
              type="text"
              value={contactName}
              onChange={e => setContactName(e.target.value)}
              placeholder="Name"
              readOnly={isReadOnlyCName}
            />
          </div>
          <div className="el flex-full">
            <input
              type="text"
              value={contactDesignation}
              onChange={e => setContactDesignation(e.target.value)}
              placeholder="Designation"
            />
          </div>
          <div className="el flex-full">
            <input
              type="text"
              value={contactEmail}
              onChange={e => setContactEmail(e.target.value)}
              placeholder="Email"
               readOnly={isReadOnlyCEmail}
            />
          </div>
          <div className="el flex-full">
            <input
              type="text"
              value={contactMobile} maxLength={15}
              onChange={(e) => {
    const value = e.target.value;
    // Allow only numbers
    if (!/^\d*$/.test(value)) return;
    // Limit to 15 digits
    if (value.length > 15) return;
    setContactMobile(value);
  }}
              placeholder="Mobile"
            />
          </div>

          <div className="el">
            <button onClick={addEditContact}>
              {contactEditIndex !== null ? "Edit" : "Add"}
            </button>
          </div>
        </div>
        <div className="row" style={{ marginTop: "2rem" }}>
          <Table
            headers={headerMap}
            data={contacts.map(x => ({
              ...x,
              contactType: x.contactType.label,
            }))}
            pagination={false}
          />
        </div>
      </div>


    </section>


  );
};

export default NewClient;
